<template>
  <div class="header-layout" :style="{ height: computedHeight }">
    <el-header class="header-content">
      <div class="slot_left">
        <slot name="left"></slot>
        <div v-show="canCollapse">
          <i :class="iconName" @click="setCollapse"></i>
        </div>
      </div>
      <div class="functional-content">
        <div class="functional-item" @click="handleOpenWindow">
          {{ $t("headerNewWindow") }}
        </div>
        <div class="functional-item" v-show="isShowDropToggle">
          <el-dropdown @command="handleRoleCommand">
            <span class="el-dropdown-link">
              {{ currentRoleDesc }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in roles"
                :key="item.roleId"
                :command="item.roleId"
                >{{ item.roleName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="functional-item">
          <el-dropdown @command="handleLangCommand">
            <span class="el-dropdown-link">
              {{ currLanguage }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in languages"
                :key="item.value"
                :command="item.value"
                >{{ item.desc }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="line"></div>
        <div class="user-info">
          <img v-show="userInfo && userInfo.sex == 'M'" :src="require('@/assets/images/male.png')" />
          <img
            v-show="userInfo && userInfo.sex == 'F'"
            :src="require('@/assets/images/female.png')"
          />
          <span>{{ userInfo && userInfo.showName }}</span>
        </div>
        <div class="exit" @click="handleLogout">
          <i class="el-icon-switch-button"></i>{{ $t("logout") }}
        </div>
      </div>
    </el-header>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      currentRoleDesc: "",
      isShowDropToggle: true,
      languages: [
        {
          desc: "简体中文",
          value: "zh_CN",
        },
        {
          desc: "繁體中文",
          value: "zh_TW",
        },
        {
          desc: "English",
          value: "en_US",
        },
      ],
      role: "",
    };
  },
  props: {
    canCollapse: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    language: {
      handler(value) {
        this.$i18n.locale = value;
        this.$cookies.set("language", value);
      },
      immediate: true,
    },
    currentRole: {
      handler(role) {
        // 判断是否有多个role 首页不显示
        if (this.roles.length > 1 && this.$route.name != "home") {
          const currentRole = this.roles.find((r) => r.roleId == role);
          if (currentRole) {
            this.isShowDropToggle = true;
            this.currentRoleDesc = currentRole ? currentRole.roleName : "";
          } else {
            this.isShowDropToggle = false;
          }
        } else {
          this.isShowDropToggle = false;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState([
      "isCollapse",
      "language",
      "userInfo",
      "roles",
      "currentRole",
      "currentModule",
    ]),
    iconName() {
      return !this.isCollapse ? "el-icon-s-fold" : "el-icon-s-unfold";
    },
    currLanguage() {
      if (this.language) {
        this.role && this.handleRoleCommand(this.role);
        return this.languages.filter((item) => item.value == this.language)[0].desc;
      } else {
        return "简体中文";
      }
    },
    computedHeight() {
      switch (true) {
        case this.isLapTop:
          return "44px";
          break;
        default:
          return "64px";
      }
    },
  },
  methods: {
    ...mapActions([
      "handleSetCollapse",
      "handleSetLanguage",
      "handleSetCurrentRole",
      "handleGetUserMenu",
      "handleClearInLogout",
      "handleSetRedirectUrl",
    ]),
    setCollapse() {
      this.handleSetCollapse(!this.isCollapse);
    },
    // 设置当前CurrentId
    handleRoleCommand(role) {
      const currentRole = this.roles.find((r) => role == r.roleId);
      if (currentRole) {
        this.handleSetCurrentRole([currentRole.roleId]);
      }
    },
    handleOpenWindow() {
      window.open(location.href);
    },
    // 切换语言
    handleLangCommand(lang) {
      // 调用actions.setLanguage
      this.handleSetLanguage(lang);
    },
    // 登出
    handleLogout() {
      console.log("process.env.VUE_APP_ENV=", process.env.VUE_APP_ENV);
      if (process.env.VUE_APP_ENV === "dev" && false) {
        localStorage.clear();
        this.handleClearInLogout();
        document.cookie = "";
        this.$router.push({
          name: "login",
        });
      } else {
        localStorage.clear();
        this.handleClearInLogout();
        document.cookie = "";
        console.log(location);
        this.$Service.fetch({
          url: "userIndex",
          params: {
            webUrl: `${location.origin}/web${this.$route.path}`,
          },
        });
        location.href = "/app/api/login/logout";
      }
      // this.$Service
      //   .fetch({
      //     url: "apiLoginLogout",
      //   })
      //   .then((res) => {
      //     localStorage.clear();
      //     this.handleClearInLogout();
      //     document.cookie = "";
      //     const iframeElem = document.createElement("iframe");
      //     iframeElem.src = "https://cas.vinda.com:8443/cas/logout";
      //     document.body.append(iframeElem);
      //     if (process.env.VUE_APP_ENV === "dev") {
      //       this.$router.push({
      //         name: "login",
      //       });
      //     } else {
      //       // this.handleSetLanguage(this.language);
      //       this.$Service.fetch({
      //         url: "userIndex",
      //         params: {
      //           webUrl: `https://pmtest.vinda.com/web${this.$route.path}`,
      //         },
      //       });
      //     }
      //   });
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
/deep/ .el-header {
  padding: 0 10px;
}
.header-layout {
  position: sticky;
  top: 0px;
  height: 64px;
  z-index: 999;
  background-color: #fff;
  color: #333;
  text-align: left;
  // box-shadow: 2px 3px 2px #ddd;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // box-shadow: 2px 3px 4px #f2f2f2;
}

.functional-content {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 10px;
  & > .functional-item {
    cursor: pointer;
    height: 32px;
    padding: 6px 10px;
    margin: 0 6px;
    font-size: 13px;
    text-align: center;
    border: solid 1px #ddd;
    border-radius: 16px;
  }
}
.user-info {
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin: 0 2px;
  }
  display: flex;
  align-items: center;
  font-size: 13px;
}
.line {
  height: 32px;
  width: 1px;
  background-color: #ddd;
  margin: 0 10px;
}

.slot_left {
  display: flex;
  align-items: center;
  i {
    margin-left: 20px;
  }
}

::v-deep .el-dropdown {
  font-size: 13px;
}

.exit {
  font-size: 13px;
  margin-left: 10px;
}
</style>
